module.exports = __webpack_public_path__ + "static/media/share-icon.f067a274.svg";